import {theme} from '../theme';
import {useWindowInnerWidth} from './shared/hooks/useWindowInnerWidth';

export function useIsResponsiveFoldable() {
  const innerWidth = useWindowInnerWidth();
  const isGreaterThanFoldable =
    innerWidth >= Number(theme.screens.foldable.replace('px', ''));
  return isGreaterThanFoldable;
}
